import moment from "moment";
import dayjs from "dayjs";

export const getDisplayDate = (date, format = "DD-MM-YYYY | HH:mm") => {
  if (date && date !== "N/A") {
    try {
      const formattedDate = moment.utc(date).format(format);

      return formattedDate !== "Invalid date" ? formattedDate : "";
    } catch (e) {
      return "";
    }
  }

  return "";
};

export const getDisplayDateIST = (date, format = "DD-MM-YYYY | HH:mm") => {
  if (date && date !== "N/A") {
    try {
      const formattedDate = moment.utc(date).utcOffset("+05:30").format(format);

      return formattedDate !== "Invalid date" ? formattedDate : "";
    } catch (e) {
      return "";
    }
  }

  return "";
};

export const getDate = (date, format) => {
  if (date && date !== "N/A") {
    try {
      let newDate = new Date(date).toISOString();
      let forMattedDate = moment(newDate).format(format);
      if (forMattedDate != "Invalid date") {
        return forMattedDate;
      } else {
        return "";
      }
    } catch (e) {}
  }
};

export const selectValueGetter = (opts, val) => {
  // if (opts.find((item) => item.value === val)) return "";
  return opts?.find(
    (item) =>
      item.value === val || item.value?.toUpperCase().replace(/_/g, "") === val,
  );
};

export const selectValueGetterr = (opts, val) => {
  if (!opts || val === undefined || val === null) return "";

  return (
    opts.find(
      (item) =>
        item.label === val ||
        item.value === val ||
        item.value?.toString().toUpperCase().replace(/_/g, "") ===
          val?.toString().toUpperCase().replace(/_/g, ""),
    ) || null
  );
};
export const selectValueGetterBoolean = (opts, val) => {
  // if (opts.find((item) => item.value === val)) return "";
  return opts.find((item) => item.value === val);
};

export const getDropdownObject = (val, arr) => {
  if (!arr) return "";
  return arr.find(
    (item) => item.value?.trim()?.toLowerCase() === val?.trim()?.toLowerCase(),
  );
};
export const getDropdownObject1 = (val, arr) => {
  if (!arr) return "";
  return arr.find((item) => item.id === val);
};

export const getMultiDropdownObject = (value, arr) => {
  if (!arr?.length) return "";
  // console.log(value?.map((val,index)=>{ return arr.find((item,ind) => item.value === val[ind])}))
  return value?.map((val) => {
    return arr.find((item) => item.value === val);
  });
};

export const parseNumeric = (str) => {
  return str.toString().replace(/[^0-9]/gi, "");
};

export const toNumberFormate = (str) => {
  if (!str) return 0;
  return str.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
};
export const getOperator = (arr, val) => {
  if (!arr) return "";
  return arr.find((item) => item.value === val);
};
export const parseNumericFloat = (str) => {
  return str.toString().match(/[+-]?([0-9]+([.][0-9]*)?|[.][0-9])/gi, "");
};
export const validateString = (str) => {
  const regex = /\S/;
  return regex.test(str);
};
export const extract10DigitNumber = (str) => {
  const regex = "^(?!\\d*(\\d)\\1{7,}|0123456789|1234567890)\\d{10,15}$";
  const match = str.match(regex);
  return match ? match[0] : null;
};

export const generateString = (length) => {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = " ";
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const validEmail = (mail) => {
  var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  if (!mail) return false;
  return mail.match(mailformat);
};
export const handleClick = () => {
  const currentDate = new Date();
  const dateInSixMonths = new Date(currentDate);
  dateInSixMonths.setMonth(currentDate.getMonth() + 6);
  const year = dateInSixMonths.getFullYear();
  const month = String(dateInSixMonths.getMonth() + 1).padStart(2, "0");
  const day = String(dateInSixMonths.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const titleCase = (str) => {
  return str.toLowerCase().replace(/\b\w/g, (s) => s.toUpperCase());
};

export const generateLastNDaysData = (days, rawData) => {
  const today = dayjs();
  const dayMap = new Map();

  // Normalize and map the rawData
  rawData?.forEach((entry) => {
    const normalizedDay = dayjs(entry.day).format("YYYY-MM-DD");
    dayMap.set(normalizedDay, {
      boxcount: entry.boxcount,
      itemcount: entry.itemcount,
    });
  });

  const boxData = [];
  const itemData = [];

  // Generate last N days and get data from map
  for (let i = 0; i < days; i++) {
    const date = today.subtract(i, "day").format("YYYY-MM-DD");

    if (dayMap.has(date)) {
      const { boxcount, itemcount } = dayMap.get(date);
      boxData.unshift(boxcount);
      itemData.unshift(itemcount);
    } else {
      boxData.unshift(0);
      itemData.unshift(0);
    }
  }

  return { boxData, itemData };
};

export const getChartDataFromRaw = (data) => {
  const weekDays = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  return data?.map((entry) => {
    const dayCountMap = Object.fromEntries(weekDays?.map((day) => [day, 0]));

    entry?.days?.forEach(({ day, count }) => {
      if (day in dayCountMap) {
        dayCountMap[day] = count;
      }
    });

    return {
      label: entry.type,
      data: weekDays.map((day) => dayCountMap[day]),
      backgroundColor:
        entry.type === "Box"
          ? "rgba(255, 99, 132, 0.7)"
          : "rgba(54, 162, 235, 0.7)",
      borderRadius: 4,
      barThickness: 20,
    };
  });
};

export const getChartDataFromRegions = (data, regionOrder) => {
  const userCounts = [];
  const scanningCounts = [];

  regionOrder?.forEach((region) => {
    const regionData = data?.find((r) => r.region === region);
    const users = regionData?.users ?? 0;
    const scannings = regionData?.transactions ?? 0;

    userCounts.push(users);
    scanningCounts.push(scannings);
  });

  return { userCounts, scanningCounts };
};

export const opList = [
  { operator: "=", label: "Equal", value: "equal" },
  { operator: "!=", label: "Not Equal", value: "not_equal" },
  { operator: "<", label: "Less", value: "less" },
  { operator: "<=", label: "Less Or Equal", value: "less_or_equal" },
  { operator: ">", label: "Greater", value: "greater" },
  { operator: ">=", label: "Greater Or Equal", value: "greater_or_equal" },
  { operator: "", label: "Between", value: "between" },
  { operator: "in", label: "In", value: "in" },
  { operator: "not in", label: "Not In", value: "not_in" },
];

export function getRouteFromSource(source) {
  switch (source) {
    case "wallet":
      return "/wallet-report";
    case "customer":
      return "/customers-list";
    case "trans":
      return "/transactions-list";
    default:
      return null;
  }
}

export function generatePLPPrimeID() {
  const timePart = Date.now().toString().slice(-3);
  const randomPart = Math.floor(100 + Math.random() * 900);

  return `PLP-${timePart}${randomPart}`;
}

export const isNumericValue = (value) =>
  (typeof value === "number" || typeof value === "string") &&
  /^[\d\s+\-.,/:%]+$/.test(String(value).trim()) &&
  /\d/.test(String(value));

export const getCellAlignProps = (cell) => {
  const cellProps = cell.getCellProps();
  return {
    ...cellProps,
    style: {
      ...cellProps.style,
      textAlign: isNumericValue(cell.value) ? "center" : "left",
    },
  };
};
